import type { ReactNode } from "react"
import Box from "@mui/material/Box"
import Container from "@mui/material/Container"
import Button from "@mui/material/Button"
import IconButton from "@mui/material/IconButton"
import Link from "@mui/material/Link"
import Typography from "@mui/material/Typography"
import TwitterIcon from "@mui/icons-material/Twitter"
import InstagramIcon from "@mui/icons-material/Instagram"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faDiscord, faTiktok } from "@fortawesome/free-brands-svg-icons"
import { WalletMultiButton } from "@solana/wallet-adapter-react-ui"
import logo from "url:../assets/images/logo.png"
import { MINT_URL } from "./MintStatus"

const MAIN_SITE_URL = "https://boredapepastelclub.com"

const socials = [
	{ label: "Instagram", href: "https://www.instagram.com/boredapepastelclub", icon: <InstagramIcon /> },
	{ label: "Twitter", href: "https://www.twitter.com/boredapepastels", icon: <TwitterIcon /> },
	{ label: "Discord", href: "https://discord.gg/QXQNcEp2Pk", icon: <FontAwesomeIcon icon={faDiscord} /> },
	{ label: "TikTok", href: "https://www.tiktok.com/@boredapepastelclub", icon: <FontAwesomeIcon icon={faTiktok} /> },
]

const Layout = ({ children }: { children: ReactNode }) => (
	<>
		<Box component="header" sx={{ position: "sticky", top: 0, zIndex: 10, backdropFilter: "blur(12px)", bgcolor: "rgba(255,248,238,.8)", borderBottom: "1px solid rgba(43,45,66,.08)" }}>
			<Container maxWidth="lg" sx={{ display: "flex", alignItems: "center", gap: 2, py: 1.5 }}>
				<Link href="/" underline="none" color="inherit" sx={{ display: "flex", alignItems: "center", gap: 1.5, mr: "auto" }}>
					<img src={logo} height={44} alt="" />
					<Typography variant="h6" component="span" sx={{ fontFamily: "\"Chelsea Market\", cursive", display: { xs: "none", sm: "block" } }}>
						Bored Ape Pastel Club
					</Typography>
				</Link>
				<Button href={MAIN_SITE_URL} sx={{ display: { xs: "none", sm: "inline-flex" }, color: "text.secondary" }}>
					Main site
				</Button>
				<Button href={MINT_URL} target="_blank" rel="noopener" variant="outlined" color="secondary" sx={{ borderRadius: 999, height: 44, px: 2.5, color: "secondary.dark", borderColor: "secondary.dark" }}>
					Mint
				</Button>
				<WalletMultiButton />
			</Container>
		</Box>
		<Container component="main" maxWidth="lg" sx={{ py: { xs: 4, md: 7 } }}>
			{children}
		</Container>
		<Box component="footer" sx={{ textAlign: "center", py: 5, borderTop: "1px solid rgba(43,45,66,.08)" }}>
			{socials.map(s => (
				<IconButton key={s.label} href={s.href} target="_blank" rel="noopener" aria-label={s.label}
					sx={{ fontSize: 26, color: "text.secondary", mx: .5, "&:hover": { color: "secondary.main" } }}>
					{s.icon}
				</IconButton>
			))}
			<Typography variant="caption" component="p" color="text.secondary" sx={{ mt: 1 }}>
				<Link href={MAIN_SITE_URL} color="inherit">Bored Ape Pastel Club</Link> · 5555 apes on Solana
			</Typography>
		</Box>
	</>
)

export default Layout
